import React from 'react';
import { useFormikContext } from 'formik';
import Alert from 'react-bootstrap/Alert';

const GeneralError = ({ error }) => {
  const { status } = useFormikContext();

  const hasError = error || status?.error;

  if (!hasError) return null;

  return (
    <Alert variant="danger" className="mb-2">
      {error || status.error}
    </Alert>
  );
};

GeneralError.propTypes = {};

export default GeneralError;
